const defaultSearchParams = {
  fusionSearchUrl: "https://docs.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2",
  fusionHowToUrl: "https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Howto_Homepage",
  fusionTypeaheadSuggestionsUrl: "https://docs.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2_typeahead",
  fusionTrendingSearchesUrl: "https://docs.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2_trending_searches",
  fusionSpellCheckUrl: 'https://docs.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2_spellcheck',
  fusionFuzzyUrl: 'https://docs.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2_fuzzy',
  params: {
    sort: '',
    start: 0,
    rows: 10,
    q: '*:*'
  }
}

// https://docs-dev.b.lucidworks.cloud:443/api/apps/Docs_Site_2/query/Docs_Site_2_typeahead

// Fallback endpoints for homepage dynamic articles/content on build
const homePageEndpoints = {
  howto: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Doc_Types?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=doc-types-howto&start=0&rows=3',
  concepts: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Doc_Types?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=doc-types-concepts&start=0&rows=3',
  reference: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Doc_Types?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=doc-types-reference&start=0&rows=3',
  getStarted: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Get_Started?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=frontpage&start=0&rows=3',
  featured: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Featured?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=frontpage&start=0&rows=3',
  mostPopular: 'https://docs.b.lucidworks.cloud/api/apps/Docs_Site_2/query/Most_Popular?q=*%3A*&fq=productName:(%22fusion%22)&fq=productVersion:(%225.10%22)&tags=frontpage&start=0&rows=3'
}

const paramNames = {
  'Products': 'productName',
  version: 'productVersion',
  type: 'docType',
  'Objective': 'objective',
  'User Role': 'persona',
  appType: 'appType'
}

module.exports = {
  defaultSearchParams,
  homePageEndpoints,
  paramNames
}
